import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	"@keyframes migrationPulse": {
		"0%": { boxShadow: `0 0 0 0 ${colors.purple[300]}99` },
		"70%": { boxShadow: `0 0 0 8px ${colors.purple[300]}00` },
		"100%": { boxShadow: `0 0 0 0 ${colors.purple[300]}00` }
	},
	disconnectButton: {
		color: colors.red[400],
		cursor: "pointer"
	},
	channelSettingsButton: {
		background: "transparent"
	},
	connectButton: {
		width: "auto",
		...ColorUtil.getBackgroundAndContrastColor(colors.green[500]),
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.green[500]),
			opacity: 0.9
		}
	},
	whatsappIconContainer: {
		borderRadius: 6,
		width: 34,
		height: 34
	},
	whatsappIcon: {
		color: colors.gray[0]
	},
	phoneNumberText: {
		fontWeight: "bold"
	},
	equalSpacedContainer: {
		width: "auto",
		[theme.breakpoints.down("sm")]: {
			width: "100%",
			alignItems: "center",
			justifyContent: "center",
			paddingBottom: theme.spacing(2)
		}
	},
	statusChip: {
		color: colors.gray[700],
		fontWeight: "bold",
		"& svg": {
			color: colors.gray[0]
		}
	},
	statusMessageContainer: {
		padding: theme.spacing(2),
		borderRadius: 6,
		boxShadow: "3px 3px 16px rgba(0, 0, 0, 0.04)"
	},
	statusMessageText: {
		maxWidth: 736
	},
	moreOptionsMenuItem: {
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent")
		}
	},
	migrationButton: {
		width: "auto",
		...ColorUtil.getBackgroundAndContrastColor(colors.purple[500]),
		animation: "$migrationPulse 2s infinite",
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		}),
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.purple[500]),
			opacity: 0.9,
			animation: "none"
		}
	}
}))

export default useStyles
